import { render, staticRenderFns } from "./MasterPort.vue?vue&type=template&id=244e99c6"
import script from "./MasterPort.vue?vue&type=script&lang=js"
export * from "./MasterPort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports